import { useState, Suspense, lazy, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Collapse from 'react-bootstrap/Collapse';
import Spinner from 'react-bootstrap/Spinner';
import InputMask from 'react-input-mask';
import Alert from 'react-bootstrap/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../redux/actions/auth'; // Importe a ação de login
import { registerUser } from '../redux/reducers/userSlice'; // Importe a ação de login
import MenuPrincipal from '../components/menuPrincipal';
import { scrollToTop } from '../util';
import menuLogo from "../assets/imagens/pentalobe.png";
const Rodape = lazy(() => import('../components/rodape'));
const AuthFlow = () => {

    const [step, setStep] = useState(0); // 0: Aviso | 1: Login | 2: Cadastro
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({ confirmPassword: '', cep: '', cpf: '' });
    const [cpf, setCpf] = useState('');
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [telefone, setTelefone] = useState('');
    const [estado, setEstado] = useState('');
    const [fullName, setFullName] = useState('');
    const [rg, setRg] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [number, setNumber] = useState('');
    const [complement, setComplement] = useState('');
    const [emailRegister, setEmailRegister] = useState('');
    const [passwordRegister, setPassordRegister] = useState('');
    const [confirmPassword, setconfirmPassword] = useState('');
    const [confirmEmail, setConfirmEmail] = useState("");
    const [loadingCep, setLoadingCep] = useState(false);
    const [enviando, setEnviando] = useState(false);
    const [errors2, setErrors2] = useState({});
    const { user } = useSelector((state) => state.user)
    const formCheckout = useRef(null);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const credentials = { email, password };
        try {
            // Despacha a ação de login e "desembrulha" o payload
            const resp = await dispatch(login(credentials)).unwrap();
            if (resp.code === 200) {
                navigate('/checkout');
            }

        } catch (error) {
            setErrorMessage(error?.errors || 'Erro ao fazer login. Por favor, tente novamente.');
        }
    };
    /*validações*/
    const validateCpf = (value) => {
        const cpfDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cpfDigits.length !== 11) {
            return "CPF inválido. Deve conter 11 dígitos.";
        }
        // Verifica se todos os dígitos são iguais (CPFs inválidos como "111.111.111-11")
        if (/^(\d)\1+$/.test(cpfDigits)) {
            return "CPF inválido. Não pode ter todos os dígitos iguais.";
        }

        // Validação dos dígitos verificadores
        let sum = 0;
        let remainder;

        // Valida o primeiro dígito verificador
        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (11 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[9])) {
            return "CPF inválido.";
        }

        // Valida o segundo dígito verificador
        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpfDigits[i - 1]) * (12 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpfDigits[10])) {
            return "CPF inválido.";
        }

        return ''; // CPF válido
    };

    const handleCepChange = (e) => {
        const value = e.target.value;
        setCep(value);
        const cepError = validateCep(value);
        setErrors((prevErrors) => ({ ...prevErrors, cep: cepError }));
        // Se o CEP tiver 8 dígitos válidos, faz a consulta
        if (!cepError && value.replace(/\D/g, '').length === 8) {
            fetchAddressFromCep(value.replace(/\D/g, ''));
        }
    };

    const handleCpfChange = (e) => {
        const value = e.target.value;
        setCpf(value);
        setErrors({ ...errors, cpf: validateCpf(value) });
    };

    const validateCep = (value) => {
        const cepDigits = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        if (cepDigits.length !== 8) {
            return "CEP inválido. Deve conter 8 dígitos.";
        }
        return '';
    };

    const fetchAddressFromCep = async (cepValue) => {
        try {
            setLoadingCep(true); // Inicia o loading
            const response = await fetch(`https://viacep.com.br/ws/${cepValue}/json/`);
            const data = await response.json();
            // console.log(data, 'data')
            if (data.erro) {
                setErrors((prevErrors) => ({ ...prevErrors, cep: 'CEP não encontrado.' }));
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
                setErrors((prevErrors) => ({ ...prevErrors, cep: '' })); // Limpa o erro se tiver sucesso
            }
        } catch (error) {
            setErrors((prevErrors) => ({ ...prevErrors, cep: 'Erro ao consultar o CEP.' }));
        } finally {
            setLoadingCep(false); // Finaliza o loading
        }
    };


    const handleRegister = async (e) => {
        e.preventDefault();
        setErrors({});
        setErrors2({});
        setEnviando(true);

        const formData = {
            fullName,
            cpf,
            rg,
            birthDate,
            telefone,
            cep,
            address: logradouro,
            number,
            complement,
            neighborhood: bairro,
            city: cidade,
            state: estado,
            email: emailRegister,
            password: passwordRegister,
            confirmEmail,
            confirmPassword
        };

        const newErrors = {};

        if (emailRegister !== confirmEmail) {
            newErrors.confirmEmail = "Os e-mails não coincidem";
        }
        if (passwordRegister !== confirmPassword) {
            newErrors.confirmPassword = "As senhas não coincidem";
        }
        const cpfError = validateCpf(cpf);
        if (cpfError) {
            newErrors.cpf = cpfError;
        }
        const cepError = validateCep(cep);
        if (cepError) {
            newErrors.cep = cepError;
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setEnviando(false);
            return;
        }

        try {
            const resultAction = await dispatch(registerUser(formData));

            if (registerUser.fulfilled.match(resultAction)) {
                console.log("Cadastro realizado com sucesso!", resultAction.payload);
                setEnviando(false);
                navigate('/checkout'); // ✅ Redireciona somente se deu certo
            } else {
                console.log("Erro no cadastro:", resultAction.payload);
                const apiErrors = resultAction.payload?.errors || {};

                const processedErrors = Object.keys(apiErrors).reduce((acc, field) => {
                    acc[field] = apiErrors[field][0]; // Pega só a primeira mensagem de erro
                    return acc;
                }, {});
                scrollToTop(formCheckout)
                setErrors2(processedErrors);
                setEnviando(false);
            }
        } catch (error) {
            console.error("Erro inesperado:", error);
            setEnviando(false);
        }
    };


    return (
        <div>
            <MenuPrincipal />
            <div className="section-spacing-3" >
                <div>
                    {/* Tela 0 - Aviso */}
                    {step === 0 && (
                        <>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <div className="login-prompt-container login-checkout" style={{ maxWidth: '700px', minHeight: '400px', borderRadius: '20px', padding: '10px' }}>
                                        <p className="login-prompt-text">
                                            Para continuar, faça login na sua conta ou crie uma nova!
                                        </p>
                                        <div className="login-prompt-buttons">
                                            <Button className="login-button" variant="primary" onClick={() => setStep(1)}>
                                                <i className="fas fa-sign-in-alt" style={{ marginRight: '8px' }}></i>
                                                Login

                                            </Button>
                                            <Button
                                                onClick={() => setStep(2)}
                                                className="register-button"
                                                variant="secondary"
                                            >
                                                <i className="fas fa-user-plus" style={{ marginRight: '8px' }}></i>
                                                Criar Conta
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* Tela 1 - Login */}
                    {step === 1 && (
                        <div>
                            <Row className='d-flex justify-content-center align-items-center login-checkout'>
                                <Col lg={4} xs={12} className='login-form'>
                                    <i onClick={() => setStep(0)} className="fa-solid fa-circle-arrow-left" style={{ marginRight: '8px', fontSize: '2em', cursor: 'pointer', color: '#F3A52C' }}></i>
                                    <a href='/'><img className="logo-menu-login mb-3" src={menuLogo} alt="fundo-imagem-home" /></a>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group controlId="formEmail">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder='Email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="formPassword">
                                            <Form.Label className='pt-3'>Senha</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder='senha'
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </Form.Group>
                                        {errorMessage && (
                                            <Alert variant="danger" className="text-center" style={{ textDecoration: "none" }}>
                                                <ul className="mb-0">
                                                    {typeof errorMessage === 'object' ? (
                                                        Object.entries(errorMessage).map(([field, messages]) =>
                                                            Array.isArray(messages) ? (
                                                                messages.map((msg, index) => (
                                                                    <li key={`${field}-${index}`}>{msg}</li>
                                                                ))
                                                            ) : (
                                                                <li key={field}>{messages}</li>
                                                            )
                                                        )
                                                    ) : (
                                                        <li>{errorMessage}</li> // Mensagem simples (string)
                                                    )}
                                                </ul>
                                            </Alert>
                                        )}
                                        <div className='text-center'>
                                            <Button variant="primary" type="submit" className='mt-3'>
                                                Entrar
                                            </Button>
                                        </div>
                                        <div className='text-center mt-3'>
                                            <a target='_black' href='/reset-senha' className='mt-3'>
                                                Esqueceu a senha?
                                            </a>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {/* Tela 2 - Cadastro */}
                    {step === 2 && (
                        <Form onSubmit={handleRegister}>
                            <div style={{ maxWidth: '700px', minHeight: '400px', margin: '0 auto', borderRadius: '20px', padding: '25px', backgroundColor: '#f8f9fa' }} ref={formCheckout}>
                                <i onClick={() => setStep(0)} className="fa-solid fa-circle-arrow-left" style={{ marginRight: '8px', fontSize: '2em', cursor: 'pointer', color: '#F3A52C' }}></i>
                                <h2 className="form-title">Dados cadastrais</h2>
                                <Row className="mb-3">
                                    {(Object.keys(errors2).length > 0) && (
                                        <Alert variant="danger" className='text-center'>
                                            {Object.keys(errors2).map((key) => (
                                                <div key={key}>{errors2[key]}</div>
                                            ))}
                                        </Alert>
                                    )}
                                    <Form.Group as={Col} md="6" controlId="fullName">
                                        <Form.Label className='mt-3'>Nome Completo</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Digite o Nome Completo"
                                            value={fullName}
                                            required
                                            onChange={(e) => setFullName(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="cpf">
                                        <Form.Label className='mt-3'>CPF</Form.Label>
                                        <InputMask
                                            mask="999.999.999-99"
                                            value={cpf}
                                            onChange={handleCpfChange}
                                            required
                                        >
                                            {(inputProps) => (
                                                <Form.Control
                                                    {...inputProps}
                                                    type="text"
                                                    placeholder="Digite o CPF"
                                                    isInvalid={!!errors.cpf}
                                                    required
                                                />
                                            )}
                                        </InputMask>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.cpf}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="6" controlId="rg">
                                        <Form.Label className='mt-3'>RG</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Digite o RG"
                                            value={rg}
                                            onChange={(e) => setRg(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="birthDate">
                                        <Form.Label className='mt-3'>Data de Nascimento</Form.Label>
                                        <InputMask
                                            mask="99/99/9999" // Formato DD/MM/YYYY
                                            value={birthDate}
                                            onChange={(e) => setBirthDate(e.target.value)}
                                            placeholder="DD/MM/AAAA"
                                        >
                                            {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                        </InputMask>
                                    </Form.Group>

                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="6" controlId="celular">
                                        <Form.Label className='mt-3'>Telefone</Form.Label>
                                        <InputMask
                                            mask="(99) 99999-9999" // Máscara para telefone com 9 dígitos no Brasil
                                            value={telefone}
                                            placeholder="Número do celular"
                                            onChange={(e) => setTelefone(e.target.value)}
                                        >
                                            {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                        </InputMask>
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="cep">
                                        <Form.Label className='mt-3'>CEP</Form.Label>
                                        <InputMask
                                            mask="99999-999"
                                            value={cep}
                                            onChange={handleCepChange}
                                        >
                                            {(inputProps) => (
                                                <Form.Control
                                                    {...inputProps}
                                                    type="text"
                                                    placeholder="Digite o CEP"
                                                    isInvalid={!!errors.cep}
                                                    required
                                                />
                                            )}
                                        </InputMask>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.cep}
                                        </Form.Control.Feedback>
                                        {/* Indicador de carregamento enquanto consulta o CEP */}
                                        {loadingCep && (
                                            <Spinner animation="border" role="status" size="sm" className="ms-2">
                                                <span className="visually-hidden">Carregando...</span>
                                            </Spinner>
                                        )}
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="6" controlId="address">
                                        <Form.Label className='mt-3'>Endereço</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Logradouro"
                                            value={logradouro}
                                            onChange={(e) => setLogradouro(e.target.value)}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="number">
                                        <Form.Label className='mt-3'>Número</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Número"
                                            value={number}
                                            onChange={(e) => setNumber(e.target.value)}
                                            required />
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="6" controlId="complement">
                                        <Form.Label className='mt-3'>Complemento</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Complemento"
                                            value={complement}
                                            onChange={(e) => setComplement(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="neighborhood">
                                        <Form.Label className='mt-3'>Bairro</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Bairro"
                                            value={bairro}
                                            onChange={(e) => setBairro(e.target.value)}
                                            readOnly
                                        />
                                    </Form.Group>

                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="6" controlId="city">
                                        <Form.Label className='mt-3'>Cidade</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Cidade"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="6" controlId="state">
                                        <Form.Label className='mt-3'>Estado</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Estado"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Row>
                                <>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="6" controlId="email">
                                            <Form.Label className='mt-3'>E-mail</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Digite seu E-mail"
                                                required
                                                value={emailRegister}
                                                onChange={(e) => setEmailRegister(e.target.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="confirmEmail">
                                            <Form.Label className="mt-3">Confirmar E-mail</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Confirme seu E-mail"
                                                required
                                                value={confirmEmail}
                                                onChange={(e) => setConfirmEmail(e.target.value)}
                                                isInvalid={!!errors.confirmEmail}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.confirmEmail}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Form.Group as={Col} md="6" controlId="password">
                                            <Form.Label className='mt-3'>Senha</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Digite a Senha"
                                                required
                                                value={passwordRegister}
                                                onChange={(e) => setPassordRegister(e.target.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="confirmPassword">
                                            <Form.Label className='mt-3'>Confirmar Senha</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Confirme a Senha"
                                                required
                                                value={confirmPassword}
                                                onChange={(e) => setconfirmPassword(e.target.value)}
                                                isInvalid={!!errors.confirmPassword}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.confirmPassword}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                </>
                                <div className='d-flex align-items-center justify-content-center mt-4'>
                                    <Button type="submit" disabled={enviando}>
                                        {enviando ? 'Enviando...' : 'Enviar'}
                                    </Button>
                                </div>
                            </div>

                            {/* Aceitação de Termos */}
                            {/*<Form.Group className="mb-3">
                                <Form.Check
                                    required
                                    label={
                                        <>
                                            <span
                                                style={{ color: "#555", textDecoration: "none", cursor: "pointer" }}
                                                onClick={() => setShowTermoModal(true)}
                                            >
                                                Li e Concordo com os <strong>Termos de Uso</strong>
                                            </span>
                                        </>
                                    }
                                    feedback="Você deve concordar antes de enviar."
                                    feedbackType="invalid"
                                    checked={termosConcordados}
                                    onChange={handleCheckboxChange}
                                />
                            </Form.Group>

                            {/* Botão de Envio */}

                        </Form>
                    )}
                </div>
            </div>
            <Suspense>
                <Rodape />
            </Suspense>
        </div>
    );
};

export default AuthFlow;
